import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import GiftCardsList from "./list";
import GiftCardCategories from "./categories";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const GiftCardViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route and if its [giftCards.base], appends list to it
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.settings.giftCards.base, exact: true})) {
            if (operatorAccessLevels.packages.sales.giftCards) {
                history.replace(routes.settings.giftCards.list);
            } else if (operatorAccessLevels.packages.sales.manageGiftCards) {
                history.replace(routes.settings.giftCards.categories);
            } else {
                history.replace(routes.settings.giftCards.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [location.pathname, history, operatorAccessLevels.packages.sales.giftCards, operatorAccessLevels.packages.sales.manageGiftCards]);

    return (
        <Switch>
            <Route path={routes.settings.giftCards.base} exact/>
            {
                operatorAccessLevels.packages.sales.giftCards &&
                <Route path={routes.settings.giftCards.list} exact>
                    <GiftCardsList/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.manageGiftCards &&
                <Route path={routes.settings.giftCards.categories} exact>
                    <GiftCardCategories/>
                </Route>
            }
            <Redirect to={routes.settings.giftCards.base.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default GiftCardViews;
